import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useAddCallRecords = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async (data: {
      accountId: string;
      pubPropertyId: string;
      checkoutId: string;
      callOutcome: string;
      callNotes: string;
      cityOfInterest: string;
      followupDate: Date | null;
      enableDnd: boolean;
      dndAt: Date | string | null;
    }) => {
      const response = await axios.post(t("call-record"), data);
      return response.data;
    },
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
      queryClient.invalidateQueries({ queryKey: ["call-records-list"] });
      queryClient.invalidateQueries({ queryKey: ["calling-pipeline-list"] });
    },
    onError: (err) => {
      if (onError) {
        onError(err);
      }
    }
  });
};
